export const StoreKey = 'entityFactory';
